import React from 'react'
import Menu from './Menu'

const NavBar = ({ MenuItems,triggerAction = {} }) => {
  return (
    <div className='common-nav'>
      <Menu
        items={MenuItems}
        onSelectedItem={(item) => {
          triggerAction(item)
        }}
      />
    </div>
  )
}
export default NavBar
